<template>
  <div>
    <div id="container" />
  </div>
</template>

<script>
  import { Chart } from '@antv/g2';
  import Global from "./Global";

  export default {
    name: "errorcount",
    mounted() {
      this.initLineChart()
    },
    methods: {
      initLineChart() {
        fetch(
          Global.accountUrl + "/storkCollectData/selectErrorCount")
          .then(res => res.json())
          .then(data => {
            const chart = new Chart({
              container: 'container',
              autoFit: true,
              height: 700,
              padding: [0, 100],
            });
            chart.data(data.data);
            chart.scale({
              value: {
                max: 50,
                min: 0,
                alias: '时间（分钟）',
              },
            });
            chart.axis('errorCode', {
              title: null,
              tickLine: null,
              line: null,
            });
            chart.axis('times', {
              label: null,
              title: {
                offset: 30,
                style: {
                  fontSize: 12,
                  fontWeight: 300,
                },
              },
            });
            chart.legend(false);
            chart.coordinate().transpose();
            chart.tooltip({
                    itemTpl: `<ul style="margin:10px">
                                <li style = "padding: 5px 0">错误描述：{errorDesc}</li>
                                <li style = "padding: 5px 0">错误次数：{times}</li>
                                <li style = "padding: 5px 0">最后时间：{lastDate}</li>
                              </ul>`,
                });
            chart
              .interval({
                sortable: true
              })
              .position('errorCode*times')
              .size(26)
              .tooltip({
                fields: ['errorDesc', 'times', 'lastDate'],
                callback: (errorDesc, times, lastDate) => {
                        return{
                            errorDesc,
                            times,
                            lastDate
                        }
                      }
              })
              .label(
                'times',
                (xValue) => {
                  return {
                    content: xValue + '次',
                  };
                },
                {
                  type: 'base', // 声明 label 类型
                }
              );
            chart.interaction('element-active');
            chart.render();
          });
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ErrorCount.vue